export default __webpack_public_path__ + "static/img2AR-aba9c9eff22b4cd88e206e633d4cc7af.png";